<template>

  <Head title="Aplikasi" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div>
        <Breadcrumbs :breadcrumbs="[
          { name: 'Dashboard', href: route('dashboard') },
          { name: 'Aplikasi', href: route('aplikasi.index') },
        ]" />

        <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
          <div class="order-2 col-span-1 space-y-6 lg:order-1">
            <div class="bg-white border border-gray-200 shadow-lg rounded-xl">
              <div
                class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4">
                <h2 class="flex items-center text-lg font-bold text-white sm:text-xl">
                  <i class="mr-2 fa-solid fa-mobile-screen-button sm:mr-3"></i>
                  {{ isEditMode ? "Edit Aplikasi" : "Tambah Aplikasi" }}
                </h2>
              </div>
              <div class="p-4 sm:p-6">
                <form class="space-y-4" @submit.prevent="submitForm">
                  <!-- Basic App Info -->
                  <div>
                    <label for="namaapps" class="block mb-2 text-sm font-medium text-gray-900">
                      Nama Aplikasi
                    </label>
                    <input v-model="form.namaapps" type="text" id="namaapps"
                      class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      placeholder="Masukkan nama aplikasi" required />
                    <div v-if="form.errors.namaapps" class="mt-1 text-sm text-red-600">
                      {{ form.errors.namaapps }}
                    </div>
                  </div>

                  <div>
                    <label for="url" class="block mb-2 text-sm font-medium text-gray-900">
                      URL Aplikasi
                    </label>
                    <input v-model="form.url" type="url" id="url"
                      class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      placeholder="https://example.com" required />
                    <div v-if="form.errors.url" class="mt-1 text-sm text-red-600">
                      {{ form.errors.url }}
                    </div>
                  </div>

                  <div>
                    <label for="logo" class="block mb-2 text-sm font-medium text-gray-900">
                      Logo Aplikasi
                    </label>
                    <input type="file" id="logo"
                      class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200 file:mr-3 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                      @change="onLogoChange" accept="image/*" />
                    <div v-if="form.errors.logo" class="mt-1 text-sm text-red-600">
                      {{ form.errors.logo }}
                    </div>
                    <div v-if="logoPreview" class="mt-3">
                      <img :src="logoPreview" alt="Preview Logo"
                        class="object-cover w-16 h-16 border border-gray-200 rounded-lg shadow-sm" />
                    </div>
                  </div>

                  <div>
                    <label for="deskripsi" class="block mb-2 text-sm font-medium text-gray-900">
                      Deskripsi
                    </label>
                    <textarea v-model="form.deskripsi" id="deskripsi" rows="3"
                      class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      placeholder="Masukkan deskripsi aplikasi"></textarea>
                    <div v-if="form.errors.deskripsi" class="mt-1 text-sm text-red-600">
                      {{ form.errors.deskripsi }}
                    </div>
                  </div>

                  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div>
                      <label for="bussinesname" class="block mb-2 text-sm font-medium text-gray-900">
                        Nama Bisnis
                      </label>
                      <input v-model="form.bussinesname" type="text" id="bussinesname"
                        class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                        placeholder="Nama bisnis" />
                      <div v-if="form.errors.bussinesname" class="mt-1 text-sm text-red-600">
                        {{ form.errors.bussinesname }}
                      </div>
                    </div>

                    <div>
                      <label for="version" class="block mb-2 text-sm font-medium text-gray-900">
                        Versi
                      </label>
                      <input v-model="form.version" type="text" id="version"
                        class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                        placeholder="v1.0.0" />
                      <div v-if="form.errors.version" class="mt-1 text-sm text-red-600">
                        {{ form.errors.version }}
                      </div>
                    </div>
                  </div>

                  <!-- Theme Picker Section -->
                  <div class="p-4 border border-gray-200 rounded-lg bg-gray-50">
                    <h3 class="mb-1 text-sm font-semibold text-gray-900">
                      🎨 Tema Tampilan (Theme)
                    </h3>
                    <p class="mb-4 text-xs text-gray-500">
                      Warna tema yang digunakan pada tampilan frontend aplikasi.
                    </p>
                    <div class="flex flex-wrap gap-3">
                      <button
                        v-for="t in themes"
                        :key="t.value"
                        type="button"
                        @click="form.theme = t.value"
                        :class="[
                          'flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg border-2 transition-colors duration-200',
                          form.theme === t.value
                            ? 'border-gray-800 bg-white'
                            : 'border-gray-200 bg-white hover:border-gray-400',
                        ]"
                      >
                        <span
                          class="inline-block w-5 h-5 border border-white rounded-full shadow"
                          :style="{ backgroundColor: t.color }"
                        ></span>
                        {{ t.label }}
                        <i
                          v-if="form.theme === t.value"
                          class="text-gray-700 fa-solid fa-check"
                        ></i>
                      </button>
                    </div>
                    <div v-if="form.errors.theme" class="mt-2 text-sm text-red-600">
                      {{ form.errors.theme }}
                    </div>
                  </div>

                  <!-- Font Picker Section -->
                  <div class="p-4 border border-gray-200 rounded-lg bg-gray-50">
                    <h3 class="mb-1 text-sm font-semibold text-gray-900">
                      🔤 Font Tampilan (Font Family)
                    </h3>
                    <p class="mb-4 text-xs text-gray-500">
                      Jenis huruf yang digunakan pada tampilan frontend.
                    </p>
                    <div class="grid grid-cols-2 gap-3 sm:grid-cols-3">
                      <button
                        v-for="f in fonts"
                        :key="f.value"
                        type="button"
                        @click="form.font_family = f.value"
                        :style="{ fontFamily: f.stack }"
                        :class="[
                          'flex items-center justify-between gap-2 px-4 py-3 text-sm rounded-lg border-2 transition-colors duration-200 bg-white',
                          form.font_family === f.value
                            ? 'border-gray-800'
                            : 'border-gray-200 hover:border-gray-400',
                        ]"
                      >
                        <span>{{ f.label }}</span>
                        <i v-if="form.font_family === f.value" class="text-gray-700 fa-solid fa-check"></i>
                      </button>
                    </div>
                    <div v-if="form.errors.font_family" class="mt-2 text-sm text-red-600">
                      {{ form.errors.font_family }}
                    </div>
                  </div>

                  <!-- Social Media Links Section -->
                  <div class="p-4 border border-gray-200 rounded-lg bg-gray-50">
                    <h3 class="mb-4 text-sm font-semibold text-gray-900">
                      🔗 Link Media Sosial
                    </h3>

                    <div class="space-y-3">
                      <div>
                        <label for="linkfb" class="block mb-1 text-sm font-medium text-gray-700">
                          Facebook
                        </label>
                        <input v-model="form.linkfb" type="url" id="linkfb"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="https://facebook.com/username" />
                      </div>

                      <div>
                        <label for="linkinstagram" class="block mb-1 text-sm font-medium text-gray-700">
                          Instagram
                        </label>
                        <input v-model="form.linkinstagram" type="url" id="linkinstagram"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="https://instagram.com/username" />
                      </div>

                      <div>
                        <label for="linkyoutube" class="block mb-1 text-sm font-medium text-gray-700">
                          YouTube
                        </label>
                        <input v-model="form.linkyoutube" type="url" id="linkyoutube"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="https://youtube.com/@username" />
                      </div>

                      <div>
                        <label for="linkemail" class="block mb-1 text-sm font-medium text-gray-700">
                          Email
                        </label>
                        <input v-model="form.linkemail" type="email" id="linkemail"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="info@example.com" />
                      </div>
                      <!-- Link tiktok-->
                      <div>
                        <label for="linktiktok" class="block mb-1 text-sm font-medium text-gray-700">
                          TikTok
                        </label>
                        <input v-model="form.linktiktok" type="url" id="linktiktok"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="https://tiktok.com/@username" />
                      </div>

                      <div>
                        <label for="linkweb" class="block mb-1 text-sm font-medium text-gray-700">
                          Website
                        </label>
                        <input v-model="form.linkweb" type="url" id="linkweb"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="https://website.com" />
                      </div>
                    </div>
                  </div>

                  <!-- Submit Buttons -->
                  <div class="pt-4 space-y-2">
                    <button type="submit"
                      class="w-full px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200">
                      <i class="mr-2 fa-solid fa-floppy-disk"></i>
                      {{ isEditMode ? "Update Aplikasi" : "Simpan Aplikasi" }}
                    </button>
                    <button v-if="isEditMode" type="button" @click="cancelEdit"
                      class="w-full px-4 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200">
                      <i class="mr-2 fa-solid fa-times"></i>
                      Batal
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="order-1 col-span-1 lg:col-span-2 lg:order-2">
            <!-- Header Section -->
            <div class="mb-4 sm:mb-6">
              <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">
                    Daftar Aplikasi
                  </h3>
                  <p class="mt-1 text-sm text-gray-600">
                    Kelola aplikasi dan informasi terkait
                  </p>
                </div>
                <div class="mt-2 text-sm text-gray-500 sm:mt-0">
                  Total: {{ filteredAplikasi.length }} aplikasi
                </div>
              </div>
            </div>

            <!-- Search Input -->
            <div class="relative mb-4">
              <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <MagnifyingGlassVue class="w-4 h-4 text-gray-400" />
              </div>
              <input v-model="search" type="text" autocomplete="off" placeholder="Cari aplikasi..." id="search"
                class="block w-full px-3 py-2.5 pl-10 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200" />
            </div>

            <!-- Table -->
            <div class="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-300">
                  <thead class="bg-gray-50">
                    <tr>
                      <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                        #
                      </th>
                      <th scope="col"
                        class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 min-w-[120px]">
                        Aplikasi
                      </th>
                      <th scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden lg:table-cell min-w-[150px]">
                        URL
                      </th>
                      <th scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden md:table-cell">
                        Info
                      </th>
                      <th scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden xl:table-cell">
                        Media Sosial
                      </th>
                      <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6 min-w-[100px]">
                        <span class="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="(item, index) in filteredAplikasi" :key="item.id"
                      class="transition-colors duration-150 hover:bg-gray-50">
                      <td class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-6">
                        {{ index + 1 }}
                      </td>
                      <td class="px-3 py-4 text-sm">
                        <div class="flex items-center">
                          <div class="flex-shrink-0 w-10 h-10 mr-3">
                            <img v-if="item.logo" :src="`/storage/${item.logo}`" alt="Logo"
                              class="object-cover w-10 h-10 border border-gray-200 rounded-lg shadow-sm" />
                            <div v-else class="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg">
                              <i class="text-gray-400 fa-solid fa-mobile-screen-button"></i>
                            </div>
                          </div>
                          <div class="flex-grow min-w-0">
                            <span class="font-medium text-gray-900 truncate">
                              {{ item.namaapps }}
                            </span>
                            <div class="text-xs text-gray-500 lg:hidden">
                              {{ item.url }}
                            </div>
                            <!-- Mobile view: Show additional info -->
                            <div class="mt-1 text-xs text-gray-500 md:hidden">
                              <div v-if="item.bussinesname">
                                {{ item.bussinesname }}
                              </div>
                              <div v-if="item.version">v{{ item.version }}</div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
                        <a :href="item.url" target="_blank" rel="noopener noreferrer"
                          class="text-indigo-600 hover:text-indigo-900 hover:underline">
                          {{ item.url }}
                        </a>
                      </td>
                      <td class="hidden px-3 py-4 text-sm text-gray-500 md:table-cell">
                        <div class="space-y-1">
                          <div v-if="item.bussinesname" class="text-xs">
                            <span class="font-medium">Bisnis:</span>
                            {{ item.bussinesname }}
                          </div>
                          <div v-if="item.version" class="text-xs">
                            <span class="font-medium">Versi:</span>
                            {{ item.version }}
                          </div>
                          <div v-if="item.deskripsi" class="text-xs text-gray-400 truncate max-w-[200px]">
                            {{ item.deskripsi }}
                          </div>
                        </div>
                      </td>
                      <td class="hidden px-3 py-4 text-sm text-gray-500 xl:table-cell">
                        <div class="flex flex-wrap gap-2">
                          <!-- ...existing social media icons... -->
                          <a v-if="item.linkfb" :href="item.linkfb" target="_blank" rel="noopener noreferrer"
                            class="inline-flex items-center justify-center w-6 h-6 text-blue-600 transition-colors duration-150 bg-blue-100 rounded-full hover:bg-blue-200"
                            title="Facebook">
                            <i class="text-xs fa-brands fa-facebook-f"></i>
                          </a>
                          <a v-if="item.linkinstagram" :href="item.linkinstagram" target="_blank"
                            rel="noopener noreferrer"
                            class="inline-flex items-center justify-center w-6 h-6 text-pink-600 transition-colors duration-150 bg-pink-100 rounded-full hover:bg-pink-200"
                            title="Instagram">
                            <i class="text-xs fa-brands fa-instagram"></i>
                          </a>
                          <a v-if="item.linkyoutube" :href="item.linkyoutube" target="_blank" rel="noopener noreferrer"
                            class="inline-flex items-center justify-center w-6 h-6 text-red-600 transition-colors duration-150 bg-red-100 rounded-full hover:bg-red-200"
                            title="YouTube">
                            <i class="text-xs fa-brands fa-youtube"></i>
                          </a>
                          <a v-if="item.linkemail" :href="`mailto:${item.linkemail}`"
                            class="inline-flex items-center justify-center w-6 h-6 text-green-600 transition-colors duration-150 bg-green-100 rounded-full hover:bg-green-200"
                            title="Email">
                            <i class="text-xs fa-solid fa-envelope"></i>
                          </a>
                          <a v-if="item.linktiktok" :href="item.linktiktok" target="_blank" rel="noopener noreferrer"
                            class="inline-flex items-center justify-center w-6 h-6 text-green-600 transition-colors duration-150 bg-green-100 rounded-full hover:bg-green-200"
                            title="TikTok">
                            <i class="text-xs fa-brands fa-tiktok"></i>
                          </a>
                          <a v-if="item.linkweb" :href="item.linkweb" target="_blank" rel="noopener noreferrer"
                            class="inline-flex items-center justify-center w-6 h-6 text-purple-600 transition-colors duration-150 bg-purple-100 rounded-full hover:bg-purple-200"
                            title="Website">
                            <i class="text-xs fa-solid fa-globe"></i>
                          </a>
                          <span v-if="
                            !item.linkfb &&
                            !item.linkinstagram &&
                            !item.linkyoutube &&
                            !item.linkemail &&
                            !item.linkweb &&
                            !item.linktiktok
                          " class="text-xs text-gray-400">
                            -
                          </span>
                        </div>
                      </td>
                      <td class="relative py-4 pl-3 pr-4 text-sm font-medium text-right sm:pr-6">
                        <div class="flex items-center justify-end space-x-1 sm:space-x-2">
                          <!-- Mobile: Show social media links -->
                          <div class="xl:hidden">
                            <div class="flex space-x-1">
                              <a v-if="item.linkfb" :href="item.linkfb" target="_blank" rel="noopener noreferrer"
                                class="inline-flex items-center justify-center w-6 h-6 text-blue-600 transition-colors duration-150 bg-blue-100 rounded-full hover:bg-blue-200"
                                title="Facebook">
                                <i class="text-xs fa-brands fa-facebook-f"></i>
                              </a>
                              <a v-if="item.linkinstagram" :href="item.linkinstagram" target="_blank"
                                rel="noopener noreferrer"
                                class="inline-flex items-center justify-center w-6 h-6 text-pink-600 transition-colors duration-150 bg-pink-100 rounded-full hover:bg-pink-200"
                                title="Instagram">
                                <i class="text-xs fa-brands fa-instagram"></i>
                              </a>
                              <!-- Add more social icons as needed -->
                            </div>
                          </div>
                          <!-- Action Buttons -->
                          <button @click="editAplikasi(item)"
                            class="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200 hover:text-indigo-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                            title="Edit">
                            <i class="w-3 h-3 fa-solid fa-pen"></i>
                            <span class="hidden ml-1 sm:inline">Edit</span>
                          </button>
                          <button @click="deleteAplikasi(item.id)"
                            class="inline-flex items-center px-2 py-1 text-xs font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200 hover:text-red-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                            title="Delete">
                            <i class="w-3 h-3 fa-solid fa-trash"></i>
                            <span class="hidden ml-1 sm:inline">Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { useForm, usePage, router } from "@inertiajs/vue3";
import { ref, computed, inject } from "vue";
import MagnifyingGlassVue from "@/Components/MagnifyingGlass.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import Swal from "sweetalert2";
const route = inject('route');

const props = defineProps({
  aplikasi: {
    type: Array,
    required: true,
  },
});

let search = ref("");

const filteredAplikasi = computed(() => {
  if (!search.value) return props.aplikasi;
  return props.aplikasi.filter((item) =>
    item.namaapps.toLowerCase().includes(search.value.toLowerCase())
  );
});

const form = useForm({
  id: null,
  namaapps: "",
  url: "",
  logo: "",
  deskripsi: "",
  bussinesname: "",
  version: "",
  theme: "maroon",
  font_family: "inter",
  linkfb: "",
  linkinstagram: "",
  linkyoutube: "",
  linkemail: "",
  linktiktok: "",
  linkweb: "",
});

const themes = [
  { value: "maroon", label: "Maroon", color: "#cc4444" },
  { value: "blue", label: "Blue", color: "#2563eb" },
  { value: "emerald", label: "Emerald", color: "#059669" },
  { value: "violet", label: "Violet", color: "#7c3aed" },
  { value: "teal", label: "Teal", color: "#0d9488" },
  { value: "navy", label: "Biru Tua", color: "#1e3a8a" },
];

const fonts = [
  { value: "inter", label: "Inter", stack: "'Inter', sans-serif" },
  { value: "poppins", label: "Poppins", stack: "'Poppins', sans-serif" },
  { value: "nunito", label: "Nunito", stack: "'Nunito', sans-serif" },
  { value: "montserrat", label: "Montserrat", stack: "'Montserrat', sans-serif" },
  { value: "merriweather", label: "Merriweather", stack: "'Merriweather', serif" },
  { value: "playfair", label: "Playfair", stack: "'Playfair Display', serif" },
  { value: "roboto-slab", label: "Roboto Slab", stack: "'Roboto Slab', serif" },
  { value: "sora", label: "Sora", stack: "'Sora', sans-serif" },
  { value: "jakarta", label: "Plus Jakarta Sans", stack: "'Plus Jakarta Sans', sans-serif" },
  { value: "dm-sans", label: "DM Sans", stack: "'DM Sans', sans-serif" },
];

const logoPreview = ref(null);

const onLogoChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    form.logo = file;
    logoPreview.value = URL.createObjectURL(file);
  } else {
    form.logo = null;
    logoPreview.value = null;
  }
};

const submitForm = () => {
  if (form.id) {
    // For update with file upload, create FormData manually
    const formData = new FormData();
    formData.append("namaapps", form.namaapps || "");
    formData.append("url", form.url || "");
    formData.append("deskripsi", form.deskripsi || "");
    formData.append("bussinesname", form.bussinesname || "");
    formData.append("version", form.version || "");
    formData.append("theme", form.theme || "maroon");
    formData.append("font_family", form.font_family || "inter");
    formData.append("linkfb", form.linkfb || "");
    formData.append("linkinstagram", form.linkinstagram || "");
    formData.append("linkyoutube", form.linkyoutube || "");
    formData.append("linkemail", form.linkemail || "");
    formData.append("linktiktok", form.linktiktok || "");
    formData.append("linkweb", form.linkweb || "");
    formData.append("_method", "PUT");

    if (form.logo && form.logo instanceof File) {
      formData.append("logo", form.logo);
    }

    router.post(route("aplikasi.update", form.id), formData, {
      onSuccess: () => {
        form.reset();
        form.id = null;
        isEditMode.value = false;
        logoPreview.value = null;
        Swal.fire({
          title: "Berhasil!",
          text: "Aplikasi berhasil diperbarui.",
          icon: "success",
          confirmButtonText: "OK",
        });
      },
      onError: (errors) => {
        Swal.fire({
          title: "Gagal!",
          text: "Terjadi kesalahan saat memperbarui aplikasi.",
          icon: "error",
          confirmButtonText: "OK",
        });
      },
    });
  } else {
    // For create, use normal form submission
    form.post(route("aplikasi.store"), {
      onSuccess: () => {
        form.reset();
        form.id = null;
        isEditMode.value = false;
        logoPreview.value = null;
        Swal.fire({
          title: "Berhasil!",
          text: "Aplikasi berhasil disimpan.",
          icon: "success",
          confirmButtonText: "OK",
        });
      },
      onError: (errors) => {
        Swal.fire({
          title: "Gagal!",
          text: "Terjadi kesalahan saat menyimpan aplikasi.",
          icon: "error",
          confirmButtonText: "OK",
        });
      },
      forceFormData: true,
    });
  }
};

const isEditMode = ref(false);

const editAplikasi = (item) => {
  isEditMode.value = true;
  form.id = item.id;
  form.namaapps = item.namaapps;
  form.url = item.url;
  form.logo = null; // Don't set the existing logo path, keep it null for file input
  form.deskripsi = item.deskripsi;
  form.bussinesname = item.bussinesname;
  form.version = item.version;
  form.theme = item.theme || "maroon";
  form.font_family = item.font_family || "inter";
  form.linkfb = item.linkfb || "";
  form.linkinstagram = item.linkinstagram || "";
  form.linkyoutube = item.linkyoutube || "";
  form.linkemail = item.linkemail || "";
  form.linktiktok = item.linktiktok || "";
  form.linkweb = item.linkweb || "";

  // Set logo preview to existing logo if available
  if (item.logo) {
    logoPreview.value = `/storage/${item.logo}`;
  } else {
    logoPreview.value = null;
  }
};

const cancelEdit = () => {
  isEditMode.value = false;
  form.reset();
  form.id = null;
  logoPreview.value = null;
};

const deleteAplikasi = async (id) => {
  const result = await Swal.fire({
    title: "Apakah Anda yakin?",
    text: "Aplikasi ini akan dihapus secara permanen!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal",
  });

  if (result.isConfirmed) {
    router.delete(route("aplikasi.destroy", id), {
      onSuccess: () => {
        Swal.fire({
          title: "Berhasil!",
          text: "Aplikasi berhasil dihapus.",
          icon: "success",
          confirmButtonText: "OK",
        });
      },
      onError: () => {
        Swal.fire({
          title: "Gagal!",
          text: "Terjadi kesalahan saat menghapus aplikasi.",
          icon: "error",
          confirmButtonText: "OK",
        });
      },
    });
  }
};
</script>
